const menu={key:"aiSprintBoard",route:"/ai-development/sprints",label:"aiDevelopment.sprints.title",permission:"ai.development.read",icon:"faLayerGroup",group:"aiDevelopment",groupLabel:"aiDevelopment.title",order:15};
export default menu;
